var map = {
	"./021_start_sound.mp3": 228,
	"./Audio": 8,
	"./Audio.tsx": 8,
	"./AudioPlayer": 25,
	"./AudioPlayer.tsx": 25,
	"./background.mp3": 230,
	"./background.ogg": 231,
	"./de/020_start.mp3": 232,
	"./de/020_start_moreInfo.mp3": 233,
	"./de/030_corner1_01.mp3": 234,
	"./de/030_corner1_02.mp3": 235,
	"./de/030_corner_bad.mp3": 236,
	"./de/030_corner_good.mp3": 237,
	"./de/030_corner_veryclose.mp3": 238,
	"./de/040_tunnel.mp3": 239,
	"./de/050_brake_01.mp3": 240,
	"./de/050_brake_02.mp3": 241,
	"./de/050_brake_good.mp3": 242,
	"./de/050_brake_tooEarly.mp3": 243,
	"./de/050_brake_tooLate.mp3": 244,
	"./de/060_corner2_01.mp3": 245,
	"./de/060_corner2_02.mp3": 246,
	"./de/070_boost.mp3": 247,
	"./en/020_start.mp3": 248,
	"./en/020_start_moreInfo.mp3": 249,
	"./en/030_corner1_01.mp3": 250,
	"./en/030_corner1_02.mp3": 251,
	"./en/030_corner_bad.mp3": 252,
	"./en/030_corner_good.mp3": 253,
	"./en/030_corner_veryclose.mp3": 254,
	"./en/040_tunnel.mp3": 255,
	"./en/050_brake_01.mp3": 256,
	"./en/050_brake_02.mp3": 257,
	"./en/050_brake_good.mp3": 258,
	"./en/050_brake_tooEarly.mp3": 259,
	"./en/050_brake_tooLate.mp3": 260,
	"./en/060_corner2_01.mp3": 261,
	"./en/060_corner2_02.mp3": 262,
	"./en/070_boost.mp3": 263,
	"./tunnel/00_mode_completed.mp3": 264,
	"./tunnel/tunnelgames_audiosprite.mp3": 265
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 227;